import { z } from 'zod';
import { MapEntity, mapEntitySchema } from 'app/agriculture/queries/types/geometry/MapEntity';
import {
    mockPointGeometry,
    PointGeometry,
    pointGeometrySchema,
} from 'app/agriculture/queries/types/geometry/PointGeometry';
import {
    BridgeCrossingType,
    bridgeCrossingTypeSchema,
} from 'app/agriculture/queries/entities/types/infrastructure/BridgeCrossingType';

export interface BridgeCrossing extends MapEntity {
    id: string;

    creatorId: number;
    createdAt: Date;
    updatedAt: Date;

    name: string;
    bridgeCrossingType: BridgeCrossingType;

    geometry: PointGeometry;
}

export const bridgeCrossingSchema = mapEntitySchema.extend({
    id: z.string().uuid(),

    creatorId: z.number(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),

    name: z.string(),
    bridgeCrossingType: bridgeCrossingTypeSchema,

    geometry: pointGeometrySchema,
});

export const mockBridgeCrossing = ({
    id = '6e9e5878-c086-408e-80aa-5ef389bd791e',

    creatorId = 1,
    createdAt = new Date(),
    updatedAt = new Date(),

    name = 'Mock Bridge Crossing Name',
    bridgeCrossingType = 'Steel',

    geometry = mockPointGeometry(),
}: Partial<BridgeCrossing> = {}): BridgeCrossing => ({
    id,

    creatorId,
    createdAt,
    updatedAt,

    name,
    bridgeCrossingType,

    geometry,
});
